import { useTranslation } from "react-i18next";
import OperationInfoItem from "../OffOperationInfo/OperationInfoItem";
import ExpendStatBadge from "../ExpendStatBadge";
import { format$Price, formatPrice } from "utils/helpers/functions/formatPrice";
import { withLocalCurrency } from "utils/helpers/currency/currencyHelpers";
import { DateTime as DT } from "luxon";
import { UserNameItem } from 'modules/user';
import vconst from "utils/helpers/structs/vconst";
import { ProductOperPrice } from 'modules/warehouse';
 
const ExpendTeamInfo = ({expendTeam}) =>{ 
 
    const { t } = useTranslation(['Objects']);
    const expend = expendTeam?.expend;
    const dt = DT.fromMillis(expend?.dt||0).toLocaleString(DT.DATETIME_FULL)
    const dtCancel = DT.fromMillis(expend?.dt_cancel||0).toLocaleString(DT.DATETIME_FULL)
    const serviceName = expend?.income_name || expend?.incomeName || '';
    const count = Number(expend?.income_count ?? expend?.incomeCount ?? 1) || 1;
    const priceOp = {
        operPrice: Number(expend?.income_price ?? expend?.incomePrice ?? expend?.income_amount ?? 0),
        operPriceRate: Number(expend?.income_price_rate ?? expend?.incomePriceRate ?? expend?.income_amount_rate ?? 0),
        operPriceSale: Number(expend?.income_price_sale ?? expend?.incomePriceSale ?? 0),
        operPriceSaleRate: Number(expend?.income_price_sale_rate ?? expend?.incomePriceSaleRate ?? 0),
    };

    return (<>
        <OperationInfoItem
            title={t('fieldsService.service')}
            infoJsx={(<>
                <ExpendStatBadge    
                    expendStatus={expend.income_status}/>
            </>)}>
            <div className="d-flex justify-content-between gap-3"> 
                <div className="min-w-0">
                    <h6 className="mb-1 text-break">{serviceName || '—'}</h6>
                    <p className="f-12 mb-0 text-muted text-break">{expend?.team_name || t('fieldsService.noTeam')}</p>
                </div>
                <div>
                    <h6 className={`mb-1 text-end ${expend.income_status === vconst.incomeStatCancel?'text-muted':'text-danger'}`}>{format$Price(-expend?.income_amount)}</h6>
                    <p className="f-12 mb-0 text-end text-truncate text-muted">{withLocalCurrency(formatPrice(expend?.income_amount_rate))}</p> 
                </div>
            </div> 
        </OperationInfoItem>

        <OperationInfoItem title={t('addService.labelCount')}>
            <h6 className="mb-0">{count}</h6>
        </OperationInfoItem>

        <OperationInfoItem title={t('fieldsService.price')}>
            <ProductOperPrice showSalePrice operation={priceOp}/>
        </OperationInfoItem>

        {expend?.income_description && 
        (<OperationInfoItem
            title={t('addService.labelDescription')}>
            <div className="d-flex justify-content-between">
                <div className="text-break" style={{ whiteSpace: 'pre-wrap' }}>{expend?.income_description}</div>
            </div>
        </OperationInfoItem>)}

        <OperationInfoItem
            title={t('fieldsService.ownerApproved')}
            infoText={dt}>
            <UserNameItem user={{
                userName       : expend?.user_name,
                userEmail      : expend?.user_email,
                userPicture    : expend?.user_picture
                }}/> 
        </OperationInfoItem>

        {expend.income_status !== vconst.incomeStatActive && 
        (<OperationInfoItem
            title={t('fieldsService.ownerCancel')}
            bg='bg-light-danger'
            infoText={dtCancel}>
            <UserNameItem user={expendTeam?.userCancel}/>
        </OperationInfoItem>)}
    </>)
}

export default ExpendTeamInfo;
